import { render, staticRenderFns } from "./WhiteSpace.vue?vue&type=template&id=f840f046&scoped=true&"
import script from "./WhiteSpace.vue?vue&type=script&lang=ts&"
export * from "./WhiteSpace.vue?vue&type=script&lang=ts&"
import style0 from "./WhiteSpace.vue?vue&type=style&index=0&id=f840f046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f840f046",
  null
  
)

export default component.exports